let cachedIP = null;

export async function getClientIP() {
  if (cachedIP) return cachedIP;
  try {
    const res = await fetch("https://api.ipify.org");
    cachedIP = await res.text();
  } catch {
    cachedIP = "";
  }
  return cachedIP;
}
